import { Component, OnInit, OnDestroy, Renderer2, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';

@Component({
  selector: 'app-digital-challenges',
  imports: [CommonModule, RouterModule],
  standalone: true,
  templateUrl: './digital-challenges.component.html',
  styleUrl: './digital-challenges.component.scss'
})
export class DigitalChallengesComponent implements OnInit,OnDestroy {
  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) { }
  private jsonLdScript: any;
  ngOnInit(): void {
    this.injectSchemaMarkup();
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route: { data: any; }) => route.data)
    )
      .subscribe((event: any) => {
        if (this.router.url === '/blogs/digital-challenges') {
          this.updateDescription(event.description, event.keywords, event.title);
        }
      });
  }
  ngOnDestroy(): void {
    this.removeSchemaMarkup();
  }

  injectSchemaMarkup(): void {
    const fullGraphSchema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/digital-challenges#webpage",
          "url": "https://www.kalpitatechnologies.com/tech-blogs/digital-challenges",
          "name": "7 Challenges Stopping Your Digital Transformation [Solutions Included]",
          "description": "Comprehensive guide to seven critical digital transformation challenges — organizational change management, legacy systems, data security, and more.",
          "isPartOf": { "@id": "https://www.kalpitatechnologies.com/#website" },
          "inLanguage": "en",
          "datePublished": "2024-01-04"
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/digital-challenges#breadcrumb",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/", "name": "Home" } },
            { "@type": "ListItem", "position": 2, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/tech-blogs/blog", "name": "Blog Index" } },
            { "@type": "ListItem", "position": 3, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/tech-blogs/digital-challenges", "name": "7 Digital Challenges" } }
          ]
        },
        {
          "@type": "BlogPosting",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/digital-challenges#blogposting",
          "headline": "7 Challenges Stopping Your Digital Transformation [Solutions Included]",
          "articleBody": "Digital transformation is leveraging digital technologies to optimize your business process. Seven major challenges include Organizational Change Management, Existing Legacy Systems, Data Security Risks...",
          "author": { "@type": "Person", "name": "Grace Catharine" },
          "publisher": {
            "@type": "Organization",
            "name": "Kalpita Technologies",
            "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
          },
          "datePublished": "2024-01-04",
          "image": "https://www.kalpitatechnologies.com/assets/resources/blog/digital-challenges/digital-challengeBanner.webp"
        },
        {
          "@type": "HowTo",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/digital-challenges#howto",
          "name": "How to Create a Digital Transformation Strategy",
          "step": [
            { "@type": "HowToStep", "position": 1, "name": "Goal Setting", "text": "Define clear goals for your digital transformation." },
            { "@type": "HowToStep", "position": 2, "name": "Business Assessment", "text": "Assess present infrastructure and identify pain points." },
            { "@type": "HowToStep", "position": 3, "name": "Adapt to Culture", "text": "Encourage a culture of continuous learning." },
            { "@type": "HowToStep", "position": 4, "name": "Create Execution Team", "text": "Build a team of technology experts." },
            { "@type": "HowToStep", "position": 5, "name": "Choose Technology", "text": "Select digital technologies that suit your processes." }
          ]
        },
        {
          "@type": "FAQPage",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/digital-challenges#faq",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What are the 7 challenges stopping digital transformation?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "The seven challenges are: Organizational Change Management, Existing Legacy Systems, Data Security Risks, Cost Considerations, Changing Customer Needs, Lack of Expertise, and Lack of Strategy."
              }
            }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://www.kalpitatechnologies.com/#organization",
          "name": "Kalpita Technologies",
          "url": "https://www.kalpitatechnologies.com/",
          "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
        }
      ]
    };

    this.jsonLdScript = this.renderer.createElement('script');
    this.jsonLdScript.type = 'application/ld+json';
    this.jsonLdScript.text = JSON.stringify(fullGraphSchema);
    this.renderer.appendChild(this._document.head, this.jsonLdScript);
  }

  removeSchemaMarkup(): void {
    if (this.jsonLdScript) {
      this.renderer.removeChild(this._document.head, this.jsonLdScript);
      this.jsonLdScript = null;
    }
  }
  updateDescription(desc: string, keywords: string, title: string) {
    // this.seoService.updateDescription(desc);
    // this.seoService.updateMetaKeywords(keywords);
    // this.seoService.updateTitle(title);
  }
}
